import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CategoryLandingProps } from '../../../../containers/MergedStore/Category/CategoryLanding.types'
import { FC } from 'react'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

export const MergedStoreCategoryTopBanner: FC<
  Pick<
    CategoryLandingProps,
    | 'topbannertitle'
    | 'topbannerdescription'
    | 'topbannerimage'
    | 'topbannerimagemobile'
    | 'topbannerimagetablet'
  >
> = ({
  topbannertitle,
  topbannerdescription,
  topbannerimage,
  topbannerimagemobile,
  topbannerimagetablet
}) => {
  return (
    <Box
      backgroundImage={{
        _: 'linear-gradient(269.7deg, #B6BFEB 0.45%, #BCC3F0 99.54%)',
        md: `url(${topbannerimagetablet?.url})`,
        lg: `url(${topbannerimage?.url})`
      }}
      backgroundPosition="center"
      backgroundSize={'cover'}
      backgroundRepeat="no-repeat"
      height={{ _: '364px', md: '188px', lg: '268px', xl: '335px' }}
      position="relative"
      justifyContent={{ _: 'center', md: 'initial' }}
      data-testid="top-banner"
    >
      <Spacer ml={{ _: 0, md: '60px' }} />
      <Box
        flexDirection={'column'}
        maxWidth={{ _: '380px', md: '330px', lg: '610px' }}
        justifyContent={{ _: 'flex-start', md: 'center' }}
      >
        <Spacer mt={{ _: '30px', md: '0px' }} />
        <PrismicText
          richTextField={topbannertitle}
          as="h1"
          fontSize={{ _: '24px', lg: '28px', xl: '42px' }}
          lineHeight={{ _: '28px', lg: '36px', xl: '56px' }}
          fontWeight={600}
          textAlign={{ _: 'center', md: 'left' }}
          padding={{ _: '0 15px', md: 0 }}
        />
        <PrismicText
          richTextField={topbannerdescription}
          as="p"
          fontSize={{ _: '16px', lg: '20px', xl: '20px' }}
          lineHeight={{ _: '20px', lg: '24px', xl: '24px' }}
          fontWeight={400}
          textAlign={{ _: 'center', md: 'left' }}
          padding={{ _: '0 15px', md: 0 }}
          marginTop={{ _: '12px' }}
        />
        {topbannerimagemobile?.url && (
          <Box
            display={{ _: 'flex', md: 'none' }}
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            maxHeight={'208px'}
            justifyContent="center"
            data-testid="mobile-image-ctr"
          >
            <Spacer mt="54px" />
            <Image src={topbannerimagemobile.url} alt={topbannerimagemobile.alt ?? ''} />
          </Box>
        )}
      </Box>
    </Box>
  )
}
